import React from 'react';
import { ChevronRight, Search, Calendar, Star, Trash2, Paperclip, Smile } from 'lucide-react';

const ChatListItem = ({ avatar, name, message, time, unread, active }) => (
  <div className={`flex items-start gap-3 p-3 rounded-lg cursor-pointer ${active ? 'bg-gray-100' : 'hover:bg-gray-50'}`}>
    <div className="relative">
      <div className="w-12 h-12 rounded-full bg-gray-300"></div>
      {unread && <span className="absolute top-0 right-0 block h-3 w-3 rounded-full bg-red-500 border-2 border-white"></span>}
    </div>
    <div className="flex-1">
      <div className="flex justify-between items-center">
        <h3 className="font-semibold text-sm text-[#1D2035]">{name}</h3>
        <p className="text-xs text-gray-400">{time}</p>
      </div>
      <p className="text-xs text-gray-500 truncate">{message}</p>
    </div>
  </div>
);

const ChatMessage = ({ message, time, isSender }) => (
    <div className={`flex items-end gap-3 ${isSender ? 'justify-end' : 'justify-start'}`}>
        {!isSender && (
            <div className="w-8 h-8 rounded-full bg-gray-300 flex-shrink-0"></div>
        )}
        <div className="max-w-md">
            <div className={`px-4 py-3 rounded-2xl ${isSender ? 'bg-[#1D2035] text-white rounded-br-none' : 'bg-white text-gray-800 rounded-bl-none'}`}>
                <p>{message}</p>
            </div>
            <div className={`text-xs mt-1 ${isSender ? 'text-right' : 'text-left'} text-gray-400`}>{time}</div>
        </div>
    </div>
);


export default function SupportTicketPage() {
  const dir = "rtl";

  const chatList = [
    { name: "مصطفى عبدالغني", message: "لوريم إيبسوم دولار سيت أميت sia sdf...", time: "10:00 مساءً", unread: true, active: true },
    { name: "صابر النجار", message: "لوريم إيبسوم دولار سيت أميت sia sdf...", time: "10:00 مساءً" },
    { name: "طارق خفاجي", message: "لوريم إيبسوم دولار سيت أميت sia sdf...", time: "10:00 مساءً" },
    { name: "أسامة فرحات", message: "يكتب Uchiha", time: "10:00 مساءً", unread: true },
    { name: "سيف الصديق", message: "لوريم إيبسوم دولار سيت أميت sia sdf...", time: "10:00 مساءً" },
    { name: "حاتم كرم", message: "لوريم إيبسوم دولار سيت أميت sia sdf...", time: "10:00 مساءً" },
    { name: "نوران سليم", message: "أفكار جديدة حول التصميم.", time: "10:30 مساءً", unread: true },
    { name: "علي حمدي", message: "استراتيجيات التسويق الرقمي.", time: "11:00 مساءً" },
    { name: "ليلى يوسف", message: "تحليل البيانات الكبيرة.", time: "11:30 مساءً" },
    { name: "حمزة عادل", message: "تطوير البرمجيات الحديثة.", time: "12:00 صباحًا", unread: true },
    { name: "فاطمة الزهراء", message: "الذكاء الاصطناعي في الفنون.", time: "12:30 صباحًا" },
    { name: "محمود سعيد", message: "إدارة المشاريع بفعالية.", time: "1:00 صباحًا" },
  ];
  
  const messages = [
    { text: "مرحبا بالجميع! لقد كنت أعمل على الصفحة المقصودة ، يرجى التحقق من ذلك ولا تنس ترك تعليق ملاحظات على figma!", time: "10:00 مساءً", isSender: false },
    { text: "أحسنت، أوتشيها! لا توجد تعليقات مني ، كل شيء يبدو على ما يرام!", time: "10:05 مساءً", isSender: true },
    { text: "ربما من الآخرين هناك ردود فعل؟", time: "10:05 مساءً", isSender: true },
    { text: "أعتقد أن هناك شيئًا مفقودًا في قسم \"نبذة عنا\" ، يبدو قاسيًا. هل يمكنك عمل خيار آخر؟", time: "10:11 مساءً", isSender: false },
    { text: "ناروتو هاهاها ، أنا أتفق معك. ربما يمكننا جعلها أفضل وأفضل!", time: "10:13 مساءً", isSender: false },
  ];

  return (
    <div className="flex h-[calc(100vh-4rem)] bg-white" dir={dir}>
      {/* Chat List Sidebar */}
      <aside className="w-1/3 border-l border-gray-200 flex flex-col">
        <div className="p-4 border-b border-gray-200">
            <div className="flex items-center justify-between">
                <h2 className="text-lg font-semibold text-[#1D2035]">رسالة</h2>
                <button className="p-1 rounded-full hover:bg-gray-100">
                    <ChevronRight size={24} className="text-gray-600" />
                </button>
            </div>
            <div className="relative mt-4">
                <input type="text" placeholder="بحث..." className="w-full py-2 pr-10 pl-4 rounded-lg border border-gray-200 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200" />
                <Search size={20} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" />
            </div>
            <div className="flex items-center justify-between mt-4 text-sm">
                <button className="flex items-center gap-2 text-gray-600">
                    <Star size={16} />
                    الأقدم
                </button>
                <button className="flex items-center gap-2 text-gray-600">
                    <Calendar size={16} />
                    شهر يناير 2025
                </button>
                <button className="text-gray-600">من الأقدم</button>
            </div>
        </div>
        <div className="flex-1 overflow-y-auto p-2">
            <h3 className="text-xs font-semibold text-gray-400 p-2">رسائل تم الرد عليها</h3>
            {chatList.map((chat, index) => (
                <ChatListItem key={index} {...chat} />
            ))}
        </div>
      </aside>

      {/* Main Chat Area */}
      <main className="flex-1 flex flex-col bg-[#f7f7f7]">
        <header className="bg-white border-b border-gray-200 p-4 flex items-center justify-between">
            <div>
                <h2 className="font-semibold text-[#1D2035]">أحمد عبد العظيم</h2>
                <p className="text-xs text-gray-400">2025/09/11 ت 04:16 م</p>
            </div>
            <button className="p-2 rounded-full bg-red-100 hover:bg-red-200">
                <Trash2 size={20} className="text-red-600" />
            </button>
        </header>
        <div className="flex-1 overflow-y-auto p-6">
            <div className="flex flex-col gap-6">
                <div className="text-center my-4">
                    <span className="px-3 py-1 text-xs text-gray-500 bg-white rounded-full border">
                        اليوم، 12 شباط/فبراير
                    </span>
                </div>
                {messages.map((msg, index) => (
                    <ChatMessage key={index} {...msg} />
                ))}
            </div>
        </div>
        <footer className="bg-white border-t border-gray-200 p-4">
            <div className="flex items-center gap-3">
                <input
                    type="text"
                    placeholder="اكتب رسالتك..."
                    className="flex-1 w-full px-4 py-3 rounded-lg border border-gray-200 bg-gray-100 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200"
                />
                <button className="p-3 rounded-lg hover:bg-gray-100">
                    <Smile size={22} className="text-gray-500" />
                </button>
                <button className="p-3 rounded-lg hover:bg-gray-100">
                    <Paperclip size={22} className="text-gray-500" />
                </button>
                <button className="px-6 py-3 text-white bg-[var(--Primary-Primary)] rounded-lg shadow-sm">
                    ارسال
                </button>
            </div>
        </footer>
      </main>
    </div>
  );
}
